import "@styles/main.scss";
import {getMessage} from "@main/helpers/get-message";
//import "@styles/main.less";

import {App} from "@main/app";

window.app = new App();
window.app.run();
window.loc = getMessage;
